export default {
  'home.top.title': '最专业的独角兽投资转让平台 ',
  'home.top.desc': '要投就投最好的',
  'home.center.title1': '热门独角兽',
  'home.center.title2': '最新公告',
  'home.center.title3': '如何操作',
  'home.center.valuation': '估值',
  'home.help.title1': '加入CTFEX',
  'home.help.title2': '投资独角兽',
  'home.help.title3': '回购和转让',
  'home.help.desc1': '1秒注册，加入投资独角兽俱乐部',
  'home.help.desc2': '浏览独角兽内参早投资赢在上市',
  'home.help.desc3': '项目上市整体退出或者直接转卖',
  'home.unicorn.purchase': '立即认购',
  'home.unicorn.transfer': '立即交易',


  ////以下是新
  'account.plan.end.title': '截止认购',
  'account.plan.stock.name': '新股',
  'account.plan.action': '决策',
  'account.plan.stock.code': '股票',
  'account.plan.onhand.got.rate': '一手中签率',
  'account.plan.sell.profit': '卖出收益',
  'account.plan.avg.profit': '中签平均收益',
  'account.plan.create.time': '创建时间',
  'account.plan.currenct.asset': '当前净值',
  'account.plan.manager': '管理人',
  'account.plan.action.now': '当前打新决策',
  'account.plan.weight.curve': '加权收益率曲线',
  'account.plan.history': '历史打新项目',
  'account.plan.notice': '提示',
  'account.plan.have.close': '本计划已封闭，不能加入',
  'account.trust.have.close': '此信托已关闭,不能申购和赎回',

  'finance.page.title': '理财',
  'finance.list.title1': '委托打新',
  'finance.list.title2': '优选理财',
  'finance.list1': '理享家优选',
  'finance.list2': '辰宇投资优选',
  'finance.list3': '善水家族办公室',
  'finance.list.tip': '请先完成专业投资者认证，如有疑问，请联系在线客服',
  'finance.table1': '价格',
  'finance.table2': '时间',
  'finance.modal1': '加入后，将跟随本计划参与打新并自动上市当天卖出。如需自主决策，您可',
  'finance.modal2': '个工作日后自由退出本计划。',
  'finance.modal3': '为最大化提高您账户资金的利用效率，本计划要求净资产在',
  'finance.modal4': '之间',
  'finance.modal5': '加入计划内',
  'finance.modal6': '天不能退出计划',
  'finance.modal7': '本计划要求净资产在',
  'finance.modal8': '之间',

  'header.nav10': '教育',
  'edu.tip': '内容仅供参考，不构成税务或投资建议，也不构成对任何证券或交易策略的建议。投资有风险，请投资者根据自身的投资偏好及知识做出投资决定。',
  'edu.library': '图书馆',
  'edu.update': '更新',
  'edu.author': 'WBroker教育',
  'edu.viewMore': '探索',
  'edu.question.title': '这回答了你的问题吗？',
  'edu.question.answer': '人中，有',
  'edu.question.answer2': '人说这回答了他们的问题。',
  'edu.used': '有用!',
  'edu.unused': '没用!',
  'edu.deal.title': '准备好开始投资了吗？',
  'edu.deal.desc': '在WBroker注册开户，并得到你的第一个股票。',
  'edu.deal': '开始交易',
  'edu.more.detail': '更多内容',

  'edu.register': '注册',

  'finance.modal9': '加入本计划净资产需大于',
  'finance.moda20': ',以及现金余额大于',
  'finance.moda21': '有新股挂单或者新股持仓时不能加入本计划',

  'account.plan.join.ok': ' 恭喜您添加成功',
  'account.plan.join.fail.notice': ' 您已参加其他委托计划，不能参加本计划',
  'account.plan.join.message.fail': ' 有挂单或者持仓时不能加入本计划',
  'account.plan.have.quit': '已退出本计划',
  'account.plan.join.fail': '委托计划失败',
  'account.plan.join.other.fail': '您已参加其他委托计划，不能参加本计划',
  'account.plan.stock.pick': '打',
  'account.plan.stock.nopick': '不打',
  'account.plan.stock.wait.pick': '待定',

  'modal.common.ok.text2': '知道了',
  'modal.common.sure.text': '确定',
  'modal.common.sure.text2': '确认',
  'modal.common.cancel.text': '取消',
  'modal.common.quit.text1': '继续开户',
  'modal.common.quit.text2': '残忍离开',

  'account.plan.join.ask': ' 确定加入计划？',
  'account.plan.quit.ask': ' 确定退出计划？',

  'account.plan.out.other.fail': '有挂单或者持仓时不能退出本计划',
  'account.plan.out.part.fail': '有新股挂单或者新股持仓时不能退出本计划',




  'form.user.set.validate.input.mobile.is.ok': '手机号不正确',
  'form.user.set.validate.input.mobile': '请输入手机号',
  'form.user.set.validate.input.email': '请输入电子邮箱',
  'form.user.set.validate.input.email.is.ok': '电子邮箱不正确',
  'form.user.set.prefix.password': '登录密码',
  'form.user.set.prefix.txpassword': '交易密码',
  'form.user.set.validate.encryptPwd.is.ok': '密码规则不匹配',
  'form.user.set.prefix.origin.password': '原登录密码',
  'form.user.set.prefix.origin.txpassword': '原交易密码',

  'form.placeholder.input.new.mobile': '请输入新手机',
  'form.user.login.prefix.new.email': '新邮箱',

  'form.safe.invest.prefix.major.income': '您的主要收入来源是',
  'form.safe.invest.major.income.A': '工资、劳务报酬',
  'form.safe.invest.major.income.B': '生产经营所得',
  'form.safe.invest.major.income.C': '利息、股息、转让等金融性资产收入',
  'form.safe.invest.major.income.D': '出租、出售房地产等非金融性资产收入',
  'form.safe.invest.major.income.E': '无固定收入',

  'form.safe.invest.prefix.house.income': '您的家庭可支配年收入为（折合人民币）',
  'form.safe.invest.house.income.A': '20万元以下',
  'form.safe.invest.house.income.B': '20-100万元',
  'form.safe.invest.house.income.C': '100-500万元',
  'form.safe.invest.house.income.D': '500-1000万元',
  'form.safe.invest.house.income.E': '1000万元以上',

  'form.safe.invest.prefix.financial.invest': '在您每年的家庭可支配收入中，可用于金融投资（储蓄存款除外）的比例为？',
  'form.safe.invest.financial.invest.A': '小于10%',
  'form.safe.invest.financial.invest.B': '10%-25%',
  'form.safe.invest.financial.invest.C': '25%-50%',
  'form.safe.invest.financial.invest.D': '大于50%',

  'form.safe.invest.prefix.debt': '您是否有尚未清偿的数额较大的债务，如有，其性质是',
  'form.safe.invest.debt.A': '没有',
  'form.safe.invest.debt.B': '有，住房抵押贷款等长期定额债务',
  'form.safe.invest.debt.C': '有，信用卡欠款、消费信贷等短期信用债务',
  'form.safe.invest.debt.D': '有，亲戚朋友借款',


  'form.safe.invest.prefix.investment.knowledge': '您的投资知识可描述为',
  'form.safe.invest.investment.knowledge.A': '有限，几乎没有金融方面的知识',
  'form.safe.invest.investment.knowledge.B': '一般，对于金融产品和相关风险具有基本的认识和理解',
  'form.safe.invest.investment.knowledge.C': '丰富，对于金融产品和相关风险具有丰富的认识和理解',


  'form.safe.invest.prefix.investment.experience.desc': '您的投资经验可描述为',
  'form.safe.invest.investment.experience.desc.A': '除银行储蓄外，基本没有其他投资经验',
  'form.safe.invest.investment.experience.desc.B': '购买过债券、保险等理财产品',
  'form.safe.invest.investment.experience.desc.C': '参与过股票、基金等产品的交易',
  'form.safe.invest.investment.experience.desc.D': '参与过权证、期货、期权等产品的交易',

  'form.safe.invest.prefix.investment.experience': '您有多少年投资基金、股票、信托、私募证券或金融衍生产品等风险投资品的经验？',
  'form.safe.invest.investment.experience.A': '没有经验',
  'form.safe.invest.investment.experience.B': '少于 2 年',
  'form.safe.invest.investment.experience.C': '2 至 5 年',
  'form.safe.invest.investment.experience.D': '5 至 10 年',
  'form.safe.invest.investment.experience.E': '10 年以上',

  'form.safe.invest.prefix.investment.horizon': '您计划的投资期限有多久',
  'form.safe.invest.investment.horizon.A': '1年以下',
  'form.safe.invest.investment.horizon.B': '1-3年',
  'form.safe.invest.investment.horizon.C': '3-5年',
  'form.safe.invest.investment.horizon.D': '5年以上',

  'form.safe.invest.prefix.investment.varieties': '您打算重点投资于哪些种类的投资品种？',
  'form.safe.invest.investment.varieties.A': '债券、货币市场基金、债券基金等固定收益类投资品种',
  'form.safe.invest.investment.varieties.B': '股票、混合型基金、股票型基金等权益类投资品种',
  'form.safe.invest.investment.varieties.C': '期货、期权等金融衍生品',
  'form.safe.invest.investment.varieties.D': '其他产品或者服务',

  'form.safe.invest.prefix.investment.attitude': '以下哪种符合您的投资态度',
  'form.safe.invest.investment.attitude.A': '厌恶风险，不希望本金损失，希望有稳定的回报',
  'form.safe.invest.investment.attitude.B': '保守投资，不希望本金损失，可以一定幅度的接受收益波动',
  'form.safe.invest.investment.attitude.C': '寻求资金的较高收益和成长性，愿意为此承担有限本金损失',
  'form.safe.invest.investment.attitude.D': '希望赚取高回报，愿意为此承担较大本金损失',

  'form.safe.invest.prefix.investment.question': '假设有两种投资：A预期获得10%的收益，可能承担的损失非常小；投资B预期获得30%的收益，但可能承担较大的损失；您会怎么支配您的投资',
  'form.safe.invest.investment.question.A': '全部投资收益较小且损失较小的A',
  'form.safe.invest.investment.question.B': '同时投资于A和B，但大部分资金投资于损失较小且收益较少的A',
  'form.safe.invest.investment.question.C': '同时投资于A和B，但大部分资金投资于损失较大且收益较多的B',
  'form.safe.invest.investment.question.D': '全部投资于收益大且风险大的B',

  'form.safe.invest.prefix.biggest.loss': '您认为自己能承受的最大损失是多少',
  'form.safe.invest.biggest.loss.A': '10%以内',
  'form.safe.invest.biggest.loss.B': '10%-30%',
  'form.safe.invest.biggest.loss.C': '30%-50%',
  'form.safe.invest.biggest.loss.D': '50%以上',

  'form.user.safe.investor.btn.submit': '提交认证',


  'form.user.safe.investor.validation.error': '本选项不符合合格投资者要求，将不能投资本网站产品',


  'form.user.safe.name.prefix.card.type': '证件类型',
  'form.user.safe.name.prefix.real.name': '姓名',
  'form.user.safe.name.prefix.card.number': '证件号码',
  'form.user.safe.name.placeholder.input.id': '请输入证件号码',
  'form.user.safe.name.placeholder.input.name': '请输入真实姓名',
  'form.user.safe.name.idcard': '身份证',
  'form.user.safe.name.passport': '护照',
  'form.user.safe.name.passport.other': '其他证件',
  'form.user.safe.name.driver': '驾照',

  'form.user.safe.name.validate.input.name': '请填写真实姓名',
  'form.user.safe.name.validate.input.idcard.is.ok': '请填写正确的身份证号码',


  'form.account.name.prefix.idcard': '身份证号',
  'form.account.name.prefix.expiry.date': '有效期截止',
  'form.account.name.placeholder.input.expiry.date': '有效期截止日期(1990-01-01)',
  'form.account.name.prefix.address': '居住地址',
  'form.account.name.placeholder.input.address': '请输入居住地址',
  'form.account.name.prefix.issue.address': '证件地址',
  'form.account.name.placeholder.input.issue.address': '请输入证件地址',
  'form.account.name.validate.idcard.error': '身份证号码有误',
  'form.account.name.validate.date.error': '有效期格式有误,(例如：1990-01-01)',
  'form.account.name.validate.input.address': '请输入地址',
  'form.account.name.prefix.address.prove': '地址证明(水电账单，信用卡账单等，须写明您的姓名的地址)',
  'form.upload.text': '点击上传',
  'form.upload.picture.to.max': '图片太大',
  'form.account.name.upload.click.front': '上传人像面',
  'form.account.name.upload.click.back': '上传国徽面',
  'form.account.name.upload.click.hold': '上传手持证件照',
  'form.account.name.card.example': '证件正确示范图，点击可查看',
  'form.account.name.prefix.show.address': '居住地址同身份证地址相同',
  'form.account.name.upload.click.info': '上传个人信息页面',
  'form.account.name.upload.click.info.back': '证件反面',
  'form.account.name.upload.click.info.hand': '上传手持证件照',
  'form.account.name.prefix.card.number': '证件号码',
  'form.user.login.validate.input.expiry.date': '请输入有效日期',
  'form.account.name.placeholder.input.card.expiry.date': '格式(YYYYMMDD-YYYYMMDD)',
  'form.account.name.validate.upload.address': '请上传地址证明文件',

  'form.account.name.upload.click.face': '点击人脸识别',


  'form.account.last.step': '上一步',
  'form.account.type': '开户证件类型',
  'form.account.type1': '大陆身份证',
  'form.account.type2': '香港身份证',
  'form.account.ocr.fail': 'ocr识别身份信息失败，请重新上传',
  'form.account.phone.tip': '拍摄提示',
  'form.account.version.old': '当前版本过旧，请前往官网下载最新版本进行开户',
  'form.account.goto.download': '去下载',
  'form.account.open.type': '开户证件',
  'form.account.open.ocr': '正在OCR识别身份',
  'form.account.open.face': '正在处理人脸信息',
  'form.account.click.cam': '请点击相机图标，进行人脸识别',
  'form.account.face.again': '人脸识别上传失败，请点击重试或联系在线客服处理',
  'form.account.face': '人脸识别',
  'form.account.click.upload': '点击上传地址证明',
  'form.account.address.approve': '点击上传地址证明',
  'form.account.house.has': '拥有',
  'form.account.house.use': '租用',
  'form.account.house.with': '与亲戚同住',
  'form.account.stepGrray1': '0年',
  'form.account.stepGrray2': '1年-3年',
  'form.account.stepGrray3': '3年-10年',
  'form.account.stepGrray4': '>10年',
  'form.account.stepGrrayChildren1': '股票、债券及其他证券',
  'form.account.stepGrrayChildren2': '杠杆外汇',
  'form.account.stepGrrayChildren3': '贵重金属',
  'form.account.stepGrrayChildren4': '期货/期权',
  'form.account.stepHrray1': '了解',
  'form.account.stepHrray2': '不了解',
  'form.account.stepHrrayChildren1': '拥有曾买卖衍生产品的经验',
  'form.account.stepHrrayChildren2': '曾接受有关衍生产品的培训或修读相关课程',
  'form.account.stepHrrayChildren3': '拥有涉及衍生工具的工作经验',
  'form.account.choose.houseStatus': '请选择住房情况',
  'form.account.houseStatus.value': '请输入估值',
  'form.account.houseStatus.number': '房屋估值只能输入数字',
  'form.account.work.status': '请选择就业状态',
  'form.account.input.work.status': '请输入就业情况',
  'form.account.choose.edu': '请选择教育程度',
  'form.account.choose.asset': '请选择总资产',
  'form.account.choose.income': '请选择年收入',
  'form.account.choose.target': '请选择投资目标',
  'form.account.choose.experience': '请选择投资经验',
  'form.account.choose.experienceType': '请选择投资类型',
  'form.account.choose.derivativesKnowledge': '请选择衍生品知识',
  'form.account.choose.hasKnowledge': '请选择衍生工具知识',
  'form.account.choose.riskTolerance': '风险承受能力项不符合监管要求，您将不能开户',
  'form.account.houseSituation': '住房情况',
  'form.account.valuation': '估值（扣除按揭）',
  'form.account.valuation.placeholder': '请填写估值',
  'form.account.work.label1': '雇主姓名',
  'form.account.work.label1.placeholder': '请输入雇主姓名',
  'form.account.work.label2': '职业/职务',
  'form.account.work.label2.placeholder': '请输入职业/职务',
  'form.account.work.label3': '任职年期',
  'form.account.work.label3.placeholder': '请输入任职年期',
  'form.account.work.label4': '职位',
  'form.account.work.label4.placeholder': '请输入职位',
  'form.account.work.label5': '业务性质',
  'form.account.work.label5.placeholder': '请输入业务性质',
  'form.account.investmentExperience': '投资类型',
  'form.account.derivativesKnowledge': '衍生品知识',
  'form.account.derivativesKnowledge0': '如何了解有关衍生工具知识',
  'form.account.risk': '风险披露',
  'form.account.risk.standar': '持牌代表：',
  'form.account.result.copy': '确定并复制微信号',
  'form.account.sign.upload.fail': '上传手写签名失败，请重试',
  'form.account.sign.reset': '重写',

  'form.placeholder.input.password.new': '8-12位字母、数字和字符组合密码',
  'form.placeholder.input.password.rule': '8-12位字母、数字和字符组合密码',

  'menu.account.name': 'WBroker实名认证 ',
  'menu.account.add': '补充资料',

  'v3.menu.plan': '理财',
  'v3.menu.plan.detail': '理财详情',

  'menu.education.detail': '教育详情',

  'account.real.name.explain.first': '1、根据监管要求，投资前您需要完成开户流程，填写相关资料评估是否符合投资者要求。',
  'account.real.name.explain.two': '2、投资证券或金融产品存在潜在的亏损可能，投资者在进行投资前需考虑自身的投资目标及风险承受能力。',
  'account.name.example.title': '照片清晰，完整，无反光',
  'account.name.example.correct.dec': '正确示范',
  'account.name.example.incomplete.dec': '不完整',
  'account.name.example.vague.dec': '模糊',
  'account.name.example.reflective.light.dec': '反光',
  'account.name.example.know': '知道了',
  'account.name.result.title': '认证成功',
  'account.login.ok': '登录成功',

  'account.open.notice.upload.face': '请上传正面照',
  'account.open.notice.upload.back': '请上传背面照',
  'account.open.notice.upload.hand': '请上传手持照',
  'account.open.notice.upload.all': '请上传全部图片',
  'account.open.notice.can.not.openaccount': '风险承受能力项不符合监管要求，您将不能开户',
  'account.open.form.title.choose': '请完成页面内容的勾选',
  'account.open.form.work.status': '就业状态',
  'account.open.form.work.hire': '受雇',
  'account.open.form.work.hire.self': '自雇',
  'account.open.form.work.other': '其它',
  'account.open.form.work.unemployed': '待业',
  'account.open.education.status': '教育程度',
  'account.open.education.status.primary': '小学或以下',
  'account.open.education.status.middle': '中学',
  'account.open.education.status.college': '大专',
  'account.open.education.status.undergraduate': '本科或以上',
  'account.open.asset.status': '总资产',
  'account.open.asset.status30': '< 30万',
  'account.open.asset.status100': '30万-100万',
  'account.open.asset.status500': '100万-500万',
  'account.open.asset.status.more': '>500万',
  'account.open.asset.year.status': '年收入',
  'account.open.asset.year.status10': '< 10万',
  'account.open.asset.year.status30': '10万-30万',
  'account.open.asset.year.status500': '30万-500万',
  'account.open.asset.year.status.more': '>500万',
  'account.open.invest.target': '投资目标',
  'account.open.invest.target.no.lose': '保本',
  'account.open.invest.target.share': '分红',
  'account.open.invest.target.all': '投资/投机',
  'account.open.invest.experience': '投资经验',
  'account.open.invest.experience.no': '没有',
  'account.open.invest.experience.soso': '一般',
  'account.open.invest.experience.much': '丰富',
  'account.open.affordability.status': '风险承受能力',
  'account.open.taffordability.status.no': '不能容忍亏损',
  'account.open.taffordability.status.low': '低(亏5-10%)',
  'account.open.taffordability.status.mid': '中(亏10-20%)',
  'account.open.taffordability.status.high': '高(亏20%以上)',
  'account.open.notice1': ' 1、根据监管要求，投资前您需要完成开户流程，填写相关资料评估是否符合投资者要求。',
  'account.open.notice2': '2、投资证券或金融产品存在潜在的亏损可能，投资者在进行投资前需考虑自身的投资目标及风险承受能力。',
  'account.open.quit.message': '确定退出开户流程吗？',
  'account.open.quit.message.present': '确定退出开户流程吗？',
  'account.open.vedio.not.support': '抱歉，你的浏览器不支持该视频 ',
  'account.open.vedio.notice': ' 风险提示：所有投资都存在风险。任何一支证券或金融产品的历史数据都不能保证其未来的表现及回报。虽然投资多样化可以帮助分散风险，但是并不能在市场低迷时确保您获益或防止您损失。投资证券或金融产品总会存在潜在的亏损可能。投资者在进行投资前需考虑自身的投资目标及风险承受能力。',
  'account.open.agrement.check': '已阅读并同意',
  'account.open.agrement.check.customer.file': '《客户协议书》',
  'account.open.agrement.check.risk': '《风险披露》',
  'account.open.agrement.check.no.usa': '《W-8Ben非美国人免税表格》',
  'account.open.agrement.check.commitment': '《投资者承诺书》',
  'account.open.agrement.check1': '本人是该证券账户的最终且唯一受益人',
  'account.open.agrement.check2': '本人与本证券公司的董事和雇员没有任何关系',
  'account.open.agrement.check3': '本人不是任何交易所，证券公司，或其他金融机构的持牌人，雇员，董事，高管',
  'account.open.agrement.check4': '本人没有担任任何重要公职，例如政府机关，军队，国有机构的重要岗位',
  'account.open.agrement.check5': '本人不是美国永久居民(绿卡持有者)',
  'account.open.end.jump': '已开户，3秒后跳转到首页',
  'account.open.need.mobile': '未绑定手机，请先绑定手机',
  'account.open.need.email': '未绑定邮箱，请先绑定邮箱',

  'account.open.end.notice1': '您的申请资料已提交审核，预计一小时内完成审核并开户',
  'account.open.end.notice2': '预计一小时内完成审核并开户',
  'account.open.end.notice3': '添加企业微信客服号：',
  'account.open.end.notice4': '即可获取价值5000元的限量新手大礼包',
  'account.open.end.notice5': '祝您投资愉快！',
  'account.open.end.notice': '您的申请资料已提交审核，预计一小时内完成 审核并开户。',
  'account.open.end.checking': '正在审核中',
  'account.open.no.liveFace': '未采集人脸图片，请重新认证',
  'account.open.upload.img.fail': '图片上传失败，请重试',
  'account.open.has.idNumber': '该证件号已存在',
  'account.open.finish.info': '请完善信息',
  'account.open.upload.img': '请上传图片信息',
  'account.open.face.live': '请先进行人脸识别',
  'account.open.ocr.finished': 'ocr已识别',
  'account.open.ocr.fail': '接口超时或网络异常，请重新上传图片',
  'account.open.lining.police': '正在连接公安部验证证件真伪',
  'account.open.comparing': '正在人证合一对比',
  'account.open.compare.approve': '人证合一通过',
  'account.open.compare.fail': '人证合一未通过,请重试',
  'account.open.check.approve': '已通过公安部身份验证',
  'account.open.check.fail': '未通过公安部身份验证',
  'account.open.check.api.fail': '公安部身份验证失败，请重试',

  'account.open.phone.code.fail': '手机验证码校验错误',
  'account.open.set.password.success': '登录密码设置成功',
  'account.open.bind.phone.success': '手机绑定成功',
  'account.open.bind.email.success': '邮箱绑定成功',
  'account.open.set.password.fail': '登录密码设置失败，重新设置',
  'account.open.bind.phone.fail': '手机绑定失败，重新绑定',
  'account.open.bind.email.fail': '邮箱绑定失败，重新绑定',
  'account.open.bind.success': '绑定并且设置成功',

  'account.open.sign.title': '手写签名',
  'account.open.sign.desc': '请确保您的手写签名与开户本人姓名保持一致。',
  'account.open.sign.reset': '重写',
  'account.open.sign.confirm': '确认签名',
  'account.open.sign.alert': '请完成手写签名',

  'v3.menu.share.open.title': 'WBroker开户',
  'v3.menu.share.open.verify': 'WBroker实名认证',
  'v3.menu.share.open.add.info': '信息补充',
  'quotation.open.account': '开户',
  'quotation.margin.account': '账户升级',
  'menu.user.safe.setting': '设置',
  'message.mail.bind-by-other': '该邮箱已经被绑定！',
  'message.code.error': '验证码错误！',
  'form.suffix.get.verify.code': '获取验证码',

  'message.login.send.success': '发送成功',

  'asset.account.open.wait.notice': '温馨提示',


  'form.account.address.title': '开户证件所属地区',
  'form.placeholder.input.password': '8-12位字符',
  'form.choose.address': '选择地区短号',
  'form.search.address': '搜索国家地区名称/国际区号',
  'form.search.input': '搜索',

  'account.plan.join': '加入计划',

  'menu.knight.rule': '骑士规则',

  'menu.user.safe.update.next': '下一步',

  'menu.notification.detail': '详情',

  'menu.help.detail': '帮助中心',
  'help.resolve.problem': '是否解决了您的问题？',
  'help.resolve.problem.yes': '是',
  'help.resolve.problem.no': '否',
  'help.relate.title': '相关问题',
  'help.answer.noUse1': '仍有疑问吗？联系',
  'help.answer.noUse2': '在线客服',
  'help.answer.noUse3': ' ',
  //仍有疑问吗？联系${在线客服}

  'form.account.type9': '本地身份证',
  'form.account.type4': '驾照',
  'form.stock.hk': '港股',
  'form.stock.us': '美股',
  'form.stock.zht': '中华通',
  'form.stock.aex': '数字货币',
  'form.account.openMarket.title': '开通市场类型',
  'account.open.agrement.aex.risk': '《数字货币风险披露》',
  'account.open.agrement.laundering': '《反洗钱条约》',
  'account.open.setPsw.title': '设置初始交易密码',
  'account.open.setPsw.title.confirm': '请再次确认交易密码',
  'account.open.setPsw.tip': '请输入6位数字',
  'account.open.setPsw.error': '密码不一致，请重新输入',
  'account.open.setPsw.bottom.tip': '*请牢记次密码，涉及交易和资金等影响账户安全的操作，都需要校验交易密码',

  'account.open.market.tip1': '账户需默认开通',
  'account.open.market.tip2': '市场',
  //账户需默认开通${港股}市场

  'help.thanks.feedBack': '感谢您的反馈',
  'component.result.back': '返回',



  'account.open.agrement.check.hkLetter.file': '《香港投资者识别码制度-个人客户同意函》',

  'menu.pi.title': '专业投资者认证',
  'pi.Title1': '什么是专业投资者？',
  'pi.Title1.desc': '根据《证券及期货（专业投资者）规则》，在最近12个月内拥有投资组合≥八百万港币（或等值货币）的个人投资者，或拥有投资组合≥八百万港币（或等值货币）或拥有总资产≥四千万港币（或等值货币）的任何法团/合伙、获托付的总资产不少于四千万港币（或等值货币）的任何信托法团，及符合要求的其他专业法团，经过认证，审核通过后可被视为专业投资者。',
  'pi.Title2': '如何认证专业投资者？',
  'pi.chooseItem1': '方式一：在WBroker持有资产800万港币以上',
  'pi.chooseItem2': '方式二：提交持有等值800万港币以上',
  'pi.chooseItem3': '资产证明',
  //方式二：提交持有等值800万港币以上资产${资产证明}
  'pi.modal.title': '资产证明要求',
  'pi.modal.tip1': '有效资产类型：现金、银行存款及证券（股票、基金、债券等）。',
  'pi.modal.tip2': '另：房产物业等固定资产证明，暂不记为有效凭证。',
  'pi.btn.text': '立即认证',
  'pi.risk.desc1': '请仔细阅读以下有关被视作专业投资者的风险及后果:',
  'pi.risk.desc2': '1.申请成为专业投资者之后，WBroker可以为您提供更多的投资产品。但该类投资产品有可能未经香港证监会认可及不受香港证监会规管，因此您投资该类产品会带有一定的风险。建议您在申请前先咨询独立第三方的专业意见。',
  'pi.risk.desc3': '2.在您申请成为专业投资者之后，WBroker可豁免履行以下义务：',
  'pi.risk.desc4': 'i. 提供有关WBroker雇员及其他代表WBroker行事的人士的身份和受雇状况的资料',
  'pi.risk.desc5': 'ii. 向您确认有关该宗交易的重点。',
  'pi.risk.desc6': 'iii. 向您提供香港联合交易所有限公司规定的关于纳斯达克-美国证券交易所试验计划的数据文件。',
  'pi.risk.desc7': 'iv. 根据《证券及期货(成交单据、户口结单及收据)规则》的要求向您提供任何成交单据、户口结单或收据。请注意，并非WBroker将停止向您履行以上义务，但是WBroker有权豁免履行。',
  'pi.risk.desc8': '3. 您若发现已不再符合专业投资者资格，必须立刻告知WBroker。您亦有权可随时通知WBroker，取消专业投资者资格。',
  'pi.statement.title': '阅读声明',
  'pi.statement.desc1': '我确认持有不少于八百万港币 (或等值外币)的投资组合。(投资组合指所持有的现金、存款和《证券及期货条例》所定义的证券) ',
  'pi.statement.desc2': '我为专业投资者在此声明，WBroker将豁免履行操守准则及其它香港相关法规中的某些要求。虽然WBroker实际上可能采取下述的一部分或全部行动，但WBroker获豁免履行下列义务：',
  'pi.statement.desc3': '1.提供有关其雇员及其他代表其行事的人士的身份和受雇状况的资料。',
  'pi.statement.desc4': '2.确认有关该宗交易的重点。',
  'pi.statement.desc5': '3.提供香港联合交易所有限公司规定的关于纳斯达克-美国证券交易所试验计划的资料文件。',
  'pi.statement.desc6': '4.根据证券及期货(成交单据、户口结单及收据)规则的要求提供任何成交单据、户口结单或收据。',
  'pi.statement.desc7': '我在此确认：',
  'pi.statement.desc8': '1.在本评估及声明表格内提供的信息准确无误；',
  'pi.statement.desc9': '2.我完全了解被界定为专业投资者的风险及后果；',
  'pi.statement.desc10': '3.我明白提交本评估表格不代表我已经获批成为专业投资者；',
  'pi.statement.desc11': '4.WBroker可以不提供任何理由而拒绝批准我成为专业投资者；',
  'pi.statement.desc12': '5.我若发现已不再符合《证券及期货(专业投资者)规则》关于专业投资者的定义时，必须立刻告知WBroker；',
  'pi.statement.desc13': '6.获告知有需要可以提出问题及征求第三方独立的意见。',
  'pi.asset.imgUpload.toast': '请上传凭证',
  'pi.authStatus.reAuth': '重新认证',
  'pi.authStatus.CERTIFIED': '已认证',
  'pi.authStatus.REVIEW': '审核中',
  'pi.auth.liveFace': '请先通过人脸识别',
  'pi.auth.liveFace.fail': '人脸识别失败，请重试',
  'pi.auth.upload.title': '上传资产凭证',
  'pi.auth.upload.desc1': '有效资产类型：12个月以内的现金、银行存款及证券（股票、基金、债券等）的账户结单、证明书。',
  'pi.auth.upload.desc2': '注：房产物业等固定资产证明，暂不记为有效凭证。',
  'pi.auth.asset.desc1': '您在WBroker的净资产合计折算为',
  'pi.auth.asset.desc2': '港币，避免市场波动导致的资产不足，请保证净资产的充余。',
  //您在WBroker的净资产合计折算为XXX港币，避免市场波动导致的资产不足，请保证净资产的充余。
  'pi.auth.asset1': 'WBroker净资产',
  'pi.auth.asset2': '港币',
  //WBroker净资产XXX港币
  'pi.auth.btn': '一键认证',
  'pi.auth.result.tip': '您的认证资料已提交审核，预计1-2个工作日内完成审核',
  'pi.auth.not.approve.reason': '未通过原因:',

  'stock.approving': '开户审核中',

  'menu.active.rule': '活动规则',


  'menu.name.zh': '姓名',
  'menu.name.zh.placeholder': '请填写真实姓名,示例：张三',
  'menu.name.zh.first': '姓(拼音)',
  'menu.name.zh.first.placeholder': '示例：ZHANG',
  'menu.name.zh.second': '名(拼音)',
  'menu.name.zh.second.placeholder': '示例：SAN',
  'user.cancel': '取消',
  'user.ok': '确认',
  'user.year': '年',
  'user.month': '月',
  'user.date': '日',
  'user.country': '国籍',
  'user.tax.country': '报税地区',
  'user.birthday': '出生日期',
  'user.birthday.placeholder': '请选择出生日期',
  'user.date.choose': '请选择日期',
  'user.experied.date': '有效期截止',
  'user.experied.placeholder': '请选择证件有效期',
  'user.experied.long.term': '长期有效',
  'user.forth.tip1': '当您点击',
  'user.forth.tip2': '“已阅读”',
  'user.forth.tip3': '按钮，表示您已阅读并了解上述风险',
  //当您点击${“已阅读”}按钮，表示您已阅读并了解上述风险
  'user.forth.btn': '已阅读',

  'menu.name.zh.first.other': '姓(英文)',
  'menu.name.zh.second.other': '名(英文)',

  'open.account.file.title': '协议签署',
  'open.account.file.desc': '本人已详细阅读并同意签署以下所有开户文件',
  'open.account.file.title2': '个人声明',

  'user.getVerifyCodeFirst': '请先获取验证码',

  'menu.updateInfo': '更新账户信息',
  'update.info.idcard': '证件类型',
  'update.face.now': '实时人脸识别',
  'update.result.text': '您的账户更新信息已提交，预计1-2小时内审核通过',
  'update.result.tip1': '如需帮助请联系',
  'update.result.tip2': '在线客服',
  'update.result.tip3': '',
  'menu.name.zh.cn': '姓名(中文)',

  'menu.trs.title': 'TRS认证',
  'tres.error.message940104': 'pi认证未通过，无法开通trs账户',
  'tres.error.message940103': '有非港币资产/负债，无法开通trs账户',
  'tres.error.message44444': '当前状态有误，无法开通trs账户',
  'tres.error.message12': '交易密码错误',
  'trs.first.title1': 'TRS认证需准备以下材料：',
  'trs.first.prepare1': '1.在有效期内的护照或港澳通行证，用于拍照上传。',
  'trs.first.prepare2': '2.近3个月的地址证明。',
  'trs.first.prepare3': '3.最近12个月内，拥有不少于港币八百万或等值外币的投资组合的户口结单（正本资产证明）。',
  'catch.error': '请求超时或者网络异常，请稍后再试',
  'trs.first.title2': '请选择证件所属地区',
  'trs.first.address.label': '证件所属地区',
  'trs.first.title3': '请选择认证证件类型',
  'trs.first.passport': '护照',
  'trs.first.Permit': '港澳通行证',
  'trs.first.save.code': '保存图片',
  'trs.first.contact.wachat': '添加TRS专属服务顾问微信',
  'trs.first.mobile': '客服电话：',
  'trs.second.finish.pic': '请完善图片信息',
  'trs.second.passport.font': '上传护照展开页',
  'trs.second.passport.hand': '上传手持护照照片',
  'trs.second.pic.font': '上传证件照正面',
  'trs.second.pic.back': '上传证件照反面',
  'trs.second.open.type': '证件类型',
  'trs.second.input.placeholder': '请输入',
  'trs.second.living.address': '居住地址',
  'trs.second.living.address.placeholder': '请输入居住地址',
  'trs.second.address.img': '地址证明(水电账单，信用卡账单等，须写明您的姓名的地址)',
  'trs.second.address.img.text': '点击上传地址证明',
  'trs.second.info': '结单信息',
  'trs.second.info.desc': '最近12个月内，拥有不少于港币八百万或等值外币的投资组合的户口结单（正本资产证明）',
  'trs.second.info.img': '点击上传结单信息',
  'trs.second.upload.meterial': '上传材料',
  'trs.fifth.ageGroupList1': '18-24岁',
  'trs.fifth.ageGroupList2': '25-34岁',
  'trs.fifth.ageGroupList3': '35-50岁',
  'trs.fifth.ageGroupList4': '51-64岁',
  'trs.fifth.ageGroupList5': '超过65岁',
  'trs.fifth.highestEducationList1': '小学或以下',
  'trs.fifth.highestEducationList2': '中学',
  'trs.fifth.highestEducationList3': '大学或以上',
  'trs.fifth.highestEducationList4': '专业资格(与会计/经济/金融学相关)',
  'trs.fifth.sourcesOfFundingList1': '薪金/佣金',
  'trs.fifth.sourcesOfFundingList2': '租金',
  'trs.fifth.sourcesOfFundingList3': '股息/利息',
  'trs.fifth.sourcesOfFundingList4': '营业利润',
  'trs.fifth.sourcesOfFundingList5': '其他',
  'trs.fifth.ageGroup': '年龄组别',
  'trs.fifth.please.choose': '请选择',
  'trs.fifth.highestEducation': '最高学历',
  'trs.fifth.liquidAsset': '流动资产',
  'trs.fifth.netAsset': '资产净值',
  'trs.fifth.annualSalary': '年薪',
  'trs.fifth.sourcesOfFunding': '资金来源',
  'trs.fifth.finance.status': '财政状况',
  'trs.sixth.title': '风险问卷',
  'trs.sixth.tip': '请先完成风险问卷中的问题',
  'trs.sixth.question1': '1、按阁下的每月平均家庭开支计算，阁下预留多少资金作为紧急用途（包括现金及任何高流动性资产，如交投活跃的股票、基金）？',
  'trs.sixth.invest1List1': '少于1个月的家庭开支',
  'trs.sixth.invest1List2': '1个月至6个月以下的家庭开支',
  'trs.sixth.invest1List3': '6个月至12个月以下的家庭开支',
  'trs.sixth.invest1List4': '12个月至24个月以下的家庭开支',
  'trs.sixth.invest1List5': '24个月或以上的家庭开支',
  'trs.sixth.invest2List1': '少于1年',
  'trs.sixth.invest2List2': '1-3年',
  'trs.sixth.invest2List3': '3-5年',
  'trs.sixth.invest2List4': '5-10年',
  'trs.sixth.invest2List5': '超过10年',
  'trs.sixth.invest3List1': '少于5%',
  'trs.sixth.invest3List2': '5%至10%以下',
  'trs.sixth.invest3List3': '10%至20%以下',
  'trs.sixth.invest3List4': '20%至30%以下',
  'trs.sixth.invest3List5': '30%或以上',
  'trs.sixth.invest4List1': '少于10%',
  'trs.sixth.invest4List2': '10%至20%以下',
  'trs.sixth.invest4List3': '20%至30%以下',
  'trs.sixth.invest4List4': '30%至40%以下',
  'trs.sixth.invest4List5': '40%或以上',
  'trs.sixth.invest5List1': '-5%至+5%之间的波动',
  'trs.sixth.invest5List2': '-10%至+10%之间的波动',
  'trs.sixth.invest5List3': '-20%至+20%之间的波动',
  'trs.sixth.invest5List4': '-30%至+30%之间的波动',
  'trs.sixth.invest5List5': '低于-30%及高于+30%的波动',
  'trs.sixth.invest6List1': '我的投资目标为保本主导。我期望获得稍高于银行存款利率的投资回报，我可以承受轻微程度的资本损失。',
  'trs.sixth.invest6List2': '我的投资目标为收入主导。我期望获得高于定期存款利率的稳定收入或抵抗通胀的定期回报，我可以承受较低资本失。',
  'trs.sixth.invest6List3': '我的投资目标为收入及增长主导。我期望获得来自资本增长及稳定收入的回报，我可以承受中等水平的投资风险。',
  'trs.sixth.invest6List4': '我的投资目标为增长主导。我期望获得来自资本增值为主而较少比重于固定收益的回报，我愿意承受较高的风险以换取更高的回报。',
  'trs.sixth.invest6List5': '我的投资目标为积极增长。我期望争取最高回报，我愿意承受极高的资本损失，甚至能承受亏损大于起初的投资本金。',
  'trs.sixth.invest7List1': '没有任何资金损失',
  'trs.sixth.invest7List2': '损失至10%',
  'trs.sixth.invest7List3': '损失至20%',
  'trs.sixth.invest7List4': '损失至20%',
  'trs.sixth.invest7List5': '全部损失',
  'trs.sixth.question2': '2、请问以下哪一项是能令您感到安心的最长投资年期？',
  'trs.sixth.question3': '3、阁下愿意拨出多少税后收入作为储蓄或投资用途?',
  'trs.sixth.question4': '4、阁下用作投资的资金平均佔阁下的总资产淨值（不包括自住物业）多少百分比？',
  'trs.sixth.question5': '5、阁下愿意接受最大程度的价格波动是多少？',
  'trs.sixth.question6': '6、阁下对投资回报与风险所持的一般态度是？',
  'trs.sixth.question7': '7、阁下可以接受的投资金额的潜在损失为多少？',
  'trs.seventh.tip': '请先完成风险问卷中投资经验相关问题',
  'trs.seventh.title': '风险问卷',
  'trs.seventh.title.desc': '8、请选择下列投资产品的投资经验',
  'trs.seventh.investList1': '无经验',
  'trs.seventh.investList2': '0-3年',
  'trs.seventh.investList3': '4-6年',
  'trs.seventh.investList4': '7-10年',
  'trs.seventh.investList5': '超过10年',
  'trs.seventh.question1': '(1).股票',
  'trs.seventh.question2': '(2).不同风险类别的交易所买卖基金',
  'trs.seventh.question3': '(3).不同风险类别的非交易所买卖基金，如互惠金、单位信託基金、对冲基金、私募股权基金等',
  'trs.seventh.question4': '(4).不同风险类别的固定收益产品，如债券',
  'trs.seventh.question5': '(5).固定收益产品（複杂类别），具有特殊性质，如永续性质、可换股性质、可赎回性质等',
  'trs.seventh.question6': '(6).上市衍生工具／结构性产品，如股票期权、期货、期货期权、认股权证等',
  'trs.seventh.question7': '(7).场外衍生工具／结构性产品，如累计期权等',
  'trs.seventh.question8': '(8).杠杆外汇投资',
  'trs.seventh.question9': '(9).其他',
  'trs.seventh.question9.placeholder': '选填',
  'trs.eighth.title': '衍生品及结构性产品认识',
  'trs.eighth.question1': '1、您是否接受过有关衍生产品或结构性的培训或修读相关课程?',
  'trs.eighth.question1.1': '培训或修读课程名称：',
  'trs.eighth.question1.2': '培训或修读日期：',
  'trs.eighth.question2': '2、您现在或过去有与衍生产品或结构性有关的工作经验?',
  'trs.eighth.question2.1': '您的雇主名称是：',
  'trs.eighth.question2.2': '在职日期：',
  'trs.eighth.question3': '3、您曾否在以往三年內执行过五宗或以上衍生产品或结构性交易?',
  'trs.eighth.yes': '是',
  'trs.eighth.no': '否',
  'trs.ninth.title1': '免责声明',
  'trs.ninth.title1.desc1': '1. 本问卷内的风险评估分析结果乃根据阁下向WBroker所提供的资料透过预设的投资风险评估程序所得。旨在协助阁下明白本身的投资需要及个人风险取向，并仅作参考用途。WBroker对风险评估分析结果的准确性及完整性并不作出任何声明或保证。分析可基于某些假设。预测的回报未必可以达到，参考结果可因既定的假设或阁下提供资料有所改变而受影响。因此，WBroker不会就此文件内所载资料或结果的准确性及完整性或阁下倚赖该等资料或结果所招致的任何后果而承担任何责任。',
  'trs.ninth.title1.desc2': '2. 阁下于作出任何投资决定前，需仔细考虑阁下的财务状况、投资经验、投资目标及风险承受能力。而且，阁下应进一步谘询专业投资顾问，以更全面了解投资证券所涉及的风险，包括（但不限于）市场风险、政治风险、信贷风险、经济风险及货币风险。阁下因应本文件的资料而作出的投资决定，WBroker恕不为该投资结果负责。',
  'trs.ninth.title1.desc3': '3. 与大多数投资项目类似，投资产品的价值可升可跌。因此，阁下可能因投资期间出现的不利市场状况而承受重大的投资损失。阁下应根据自身风险承受能力及情况而投资。本文件所包含之投资选择仅作参考用途，并不能代替适当的专业投资建议。',
  'trs.ninth.title1.desc4': '4. WBroker有权不时更改或修订本文件之内容而无须作事先通知。如有任何争议，WBroker有最终决定权。',
  'trs.ninth.title1.desc5': '5. 此文件所载资料只备作参考用途，并不构成任何金融产品之要约、游说、邀请、意见或建议。投资涉及风险，过往的表现不能预示将来的表现，在作出投资前，阁下应参阅有关招售文件内的详细资料。',
  'trs.ninth.title1.desc6': '6. 如阁下对此资料有疑问，应寻求独立专业财务、税务及法律意见。',
  'trs.ninth.title2': '个人资料收集声明',
  'trs.ninth.title2.desc': '收集之个人资料将被使用于以下用途。基于实际的商业及营运需要，该等资料可能被（i）WBroker任何成员之行政、运作及资讯科技部门；（ii）任何向WBroker提供服务之供应商，而该服务供应商就其提供有关服务是有合理需要知道相关资料的；（iii）任何与WBroker有业务关係的商业伙伴或其他金融产品发行人，而该伙伴或发行人就其提供有关金融产品予客户是有合理需要知道相关资料的；及（iv）任何对WBroker任何成员具有适当管辖权之政府机关、司法机关、法定机关或业界自我监管机关。除用于上述目的外，阁下之个人资料将会保密。如此表格不再适用于以上所提及之任何用途，将于其后一年内被销毁；但此表格可能会被保留一段相当时间，以符合有关法律及监管要求。',
  'trs.tenth.tip1': '请勾选个人声明',
  'trs.tenth.tip2': '请先完成签署协议',
  'trs.tenth.title1': '个人声明',
  'trs.tenth.title1.desc1': '本人确认本人的上述回答为真实、正确而且准确的；',
  'trs.tenth.title1.desc2': '本人确认WBroker可根据本人提供的信息来确定本人的风险状况，以及适合本人的投资产品类型；',
  'trs.tenth.title1.desc3': '如本人在填写的资料有任何变动，本人同意以书面形式通知WBroker，并明白WBroker将继续依照记录中的最新版本，直至WBroker收到我所提供的更新版本为止；',
  'trs.tenth.title1.desc4': '本人确认已根据填写指引，提供本认证的答案，亦明白WBroker在评估投资产品对帐户的合适性时，可能会参照本问卷的答案，尽管该帐户的其他帐户持有人可能分别具有不同的投资知识和经验，风险，能力，风险承受能力，财务状况和投资目标；',
  'trs.tenth.title1.desc5': '本人已阅读，明白并同意包括本认证内容内所有细节；',
  'trs.tenth.title1.desc6': '本人了解由本人提供的任何欠缺准确性或不完整的信息，都可能影响WBroker对本人所提供的投资产品和服务适用性评估；',
  'trs.tenth.title1.desc7': '本人明白并接受WBroker不会为本人做出任何最终投资决定，本人需要为自己的投资决定负责，包括所提供的产品或服务，最终是否满足本人个人需求或情况。',
  'trs.tenth.title2': '签署协议',
  'trs.tenth.title2.desc': '本人已详细阅读并同意签署以下所有认证协议',
  'trs.result.desc': '您的认证资料已提交审核，预计1-2个工作日内完成审核。',
  'trs.result.back.homePage': '返回首页',
  'update.info.checking': '您已提交账户信息，请耐心等待审核！',

  'trust.fixedAmountLimit.label': '认购金额',
  'trust.fixedAmountLimit.label.placeholder': '请输入认购金额',
  'trust.purchurs.amount.label': '认购份额',
  'trust.intrustCode.label': '邀请码',
  'trust.intrustCode.placeholder': '请输入邀请码',
  'trust.password.label': '交易密码',
  'trust.password.placeholder': '请输入交易密码',
  'trust.sell.label': '赎回份额',
  'intrust.title': '信托详情',
  'intrust.his.tab.title': '历史净值',
  'intrust.his.amount.shares': '份',

  'menu.report.detail': '详情',

  'ipo.header.title': '信托详情',
  'ipo.subscription.header.title': '认购',
  'IpoResult.header.title': '认购',
  'ipo.per.amount': '每份投资金额',
  'ipo.amount.placeholder': '请输入认购份额',
  'trs.asset.cashValue': '可用现金:',
  'ipo.limit': '*限购',
  'ipo.limit1': '份',
  'ipo.tip': '*交易日16:00-20:00时可能因系统结算导致认购失败',
  'ipo.contract1': '已阅读并同意电子签署',
  'ipo.contract2': '协议',
  'ipo.time': '认购时间',
  'ipo.product': '产品',
  'ipo.sucess': '认购成功',
  'ipo.error170014': '认购代码无效',
  'ipo.error171000': '认购数量错误',
  'ipo.error171001': '认购数量超过个人额度',
  'ipo.error171002': '已售罄',
  'ipo.error171003': '暂不支持赎回',

  'raffle.index.title': '新年抽股大放送',
  'update.man': '男',
  'update.woman': '女',
  'update.sex': '性别',

  'account.market.tip1': '账户需默认开通',
  'account.market.tip2': '市场',
  'account.market.title': '请确认您要开通的账户类型',
  'account.market.error': '请选择账户类型',
  'account.market.type1': '孖展（保证金）账户',
  'account.market.type1.desc': '孖展（保证金）账户，可使用自有现金交易，也可借入资金交易。',
  'account.market.type2': '现金账户',
  'account.market.type2.desc': '现金账户，仅可使用自有现金交易，不允许借贷融资交易。',
  'account.market.type.title': '请确认您要开通的市场类型',
  'account.market.type.error': '请选择市场类型',
  'account.market.type.HK': '港股',
  'account.market.type.US': '美股',
  'account.market.type.CN': '中华通',

  'account.bank.no.label': '银行卡号',
  'account.bank.no.placeholder': '请输入大陆银联银行卡号',
  'account.bank.account.name.label': '银行开户户名',
  'account.bank.account.mobile.label': '手机号',
  'account.bank.account.mobile.placeholder': '请输入银行开户预留手机号',
  'account.ca.tips1': '1、根据监管要求，投资前您需要完成开户流程，填写相关资料评估是否符合投资者要求。',
  'account.ca.tips2': '2、华通国际将会对您的信息进行严格保密。',
  'account.ca.tips3': '3、此银行卡仅用于身份实名认证。',
  'ca.error.tip': 'Ca认证失败:',
  'ca.menu.title': '身份认证',
  'ca.index.btn': '开始认证',
  'ca.upload.tip1': '1、华通国际将会对您的信息进行严格保密。',
  'ca.upload.tip2': '2、身份证信息仅用于身份实名认证。',
  'agreement.error.tip': '请先勾选协议',
  'ca.index.title': '为了保障您的资产安全，请您完成身份认证',
  'ca.index.tip1': '请您确保环境安静，光线充足',
  'ca.index.tip2': '请您提前准备好大陆银联银行卡',
  'ca.index.agreement1': '身份认证服务由GDCA提供，本人已阅读并同意',
  'ca.index.agreement2': 'GDCA数字证书用户协议',
  'ca.index.agreement3': '和',
  'ca.index.agreement4': '申请数字证书相关条款',
  'open.end.tips1': '开户资料已提交',
  'open.end.tips2': '预计在1个工作日内开户成功',
  'update.place.of.birth': '出生地',
  'update.residence': '常驻地区',
  'form.account.valuation2': '估值（扣除按揭）',



  'account.open.bank.name': '银行名称',

  // 调查问卷
  'account.open.asset.status20': '< 20万',
  'account.open.asset.status2050': '20万-50万',
  'account.open.asset.status50100': '50万-100万',
  'account.open.asset.status100500': '100万-500万',
  'account.open.asset.status5001000': '500万-1000万',
  'account.open.asset.status.1000+': '>1000万',
  'account.open.asset.status.Negative.equity': '负资产',
  'account.open.asset.year.status20': '< 20万',
  'account.open.asset.year.status2050': '20万-50万',
  'account.open.asset.year.status50100': '50万-100万',
  'account.open.asset.year.status100500': '100万-500万',
  'account.open.asset.year.status5001000': '500万-1000万',
  'account.open.asset.year.status.1000+': '>1000万',
  'account.open.questionnaire.source.type1': '储蓄',
  'account.open.questionnaire.source.type2': '工资收入',
  'account.open.questionnaire.source.type3': '租金',
  'account.open.questionnaire.source.type4': '家族继承',
  'account.open.questionnaire.source.type5': '创业',
  'account.open.questionnaire.source.type6': '投资收益',
  'account.open.questionnaire.source.type7': '其他',
  'account.open.questionnaire.objective.type1': '资本投资',
  'account.open.questionnaire.objective.type2': '对冲',
  'account.open.questionnaire.objective.type3': '投机',
  'account.open.questionnaire.objective.type4': '股息/利息收入',
  'account.open.questionnaire.title1': '就业情况',
  'account.open.questionnaire.title2': '公司名称',
  'account.open.questionnaire.title3': '职业/职务',
  'account.open.questionnaire.title4': '职务年期',
  'account.open.questionnaire.title5': '职位',
  'account.open.questionnaire.title6': '教育情况',
  'account.open.questionnaire.title7': '收入情况',
  'account.open.questionnaire.title8': '净资产',
  'account.open.questionnaire.title9': '财富来源(可多选)',
  'account.open.questionnaire.title10': '交易资金来源(可多选)',
  'account.open.questionnaire.title11': '投资目的',
  'account.open.questionnaire.title12': '投资经验',
  'account.open.questionnaire.title13': '投资杠杆',
  'account.open.questionnaire.title14': '投资贵金属',
  'account.open.questionnaire.title15': '投资期权',
  'account.open.questionnaire.title16': '衍生品知识',
  'account.open.questionnaire.title17': '风险承受能力',
  'account.open.questionnaire.title18': '净资产(港币)',
  'account.open.questionnaire.title19': '不包括居住地方、汽车、家私、个人物品及人寿保险',
  'account.open.questionnaire.title20': '投资股票、债券及其他证券',
  'account.open.questionnaire.title21': '投资杠杆外汇',
  'account.open.questionnaire.title22': '投资贵重金属',
  'account.open.questionnaire.title23': '投资期货/期权',
  'account.open.questionnaire.title24': '是否了解衍生产品',
  'account.open.questionnaire.title25': '年收入(港币)',


  'account.open.License.Number': '持牌号',
  'account.open.bank.check.tips': '请使用与开户同名大陆银行卡进行身份认证，用以满足证监会的监管要求',

  'account.open.bank.check.UnionPay.bank': '请输入大陆银联银行名称',
  'account.open.bank.check.11': '手机号限制在11位',


  'account.open.derivative.title': '如何了解衍生产品知识',
  'account.open.derivative.1': '过去3年内进行5次或以上有关衍生产品交易',
  'account.open.derivative.2': '曾接受有关衍生产品的培训或修读相关课程',
  'account.open.derivative.3': '拥有涉及衍生产品的工作经验',
  'account.open.derivative.4': '培训或课程名称',
  'account.open.derivative.5': '培训或课程日期',
  'account.open.search.tips': '国家地区名称',

  'margin.tips': '投资证券或金融产品存在潜在的亏损可能，投资者在进行投资前需考虑自身的投资目标及风险承受能力。',
  'margin.end': '账户已升级',
  'margin.agreement.tips': '本人已详细阅读并同意签署',
  'margin.agreement.tips2': '《账户升级授权书》',

}
